var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.rootClass},[(_vm.$slots.head)?[_c('BravadoText',{staticClass:"jobs-profile-section__head",attrs:{"variant":"headline-semibold"}},[_vm._t("head")],2),_vm._v(" "),_c('hr',{staticClass:"jobs-profile-section__separator"})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }